// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltOutlinedSvg from "@fishx/icons-svg/es/asn/ThunderboltOutlined";
import FishxIcon from '../components/FishxIcon';

var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltOutlinedSvg
  }));
};

ThunderboltOutlined.displayName = 'ThunderboltOutlined';
export default React.forwardRef(ThunderboltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ThunderboltOutlined.js
// module id = 4260
// module chunks = 0